
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/o-projektu",
      function () {
        return require("private-next-pages/o-projektu.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/o-projektu"])
      });
    }
  